import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-button',
  imports: [CommonModule],
  templateUrl: './home-button.component.html',
  styleUrl: './home-button.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeButtonComponent {
  @Input() public rounded: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'pill' | 'full' = 'md';
  @Input() public variant: 'default' | 'text' | 'outlined' = 'default';
  @Input() public color: 'primary' | 'secondary' | 'white' = 'primary';
  @Input() public flat = false;
  @Input() public disabled = false;
  @Input() public type: 'button' | 'submit' | 'reset' = 'button';

  protected get classes() {
    return {
      [`rounded-${this.rounded}`]: !!this.rounded,
      [`color-${this.color}`]: !!this.color,
      flat: this.flat,
      text: this.variant === 'text',
      outlined: this.variant === 'outlined',
    };
  }
}
